var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "664.000000pt",
    height: "666.000000pt",
    viewBox: "0 0 664.000000 666.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,666.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1548 6075 c-217 -41 -418 -154 -582 -325 -238 -249 -338 -576 -337 -1100 0 -402 50 -759 161 -1149 251 -884 739 -1607 1525 -2261 61 -50 111 -95 113 -99 1 -4 -33 -15 -75 -25 -242 -57 -530 -165 -848 -320 -308 -150 -627 -333 -598 -343 6 -2 49 11 95 30 142 59 525 177 768 237 677 166 1627 214 2445 125 249 -28 608 -110 847 -194 254 -90 15 44 -347 194 -484 201 -1001 330 -1408 351 -70 4 -124 10 -120 15 15 14 253 113 634 264 878 348 1233 525 1584 790 414 312 710 751 766 1134 64 444 -212 838 -651 927 -105 21 -293 14 -423 -15 -281 -64 -604 -227 -867 -437 -110 -88 -337 -315 -424 -424 -376 -473 -665 -1136 -880 -2016 -26 -104 -49 -199 -51 -211 -3 -14 -15 -24 -36 -28 -17 -4 -33 -5 -35 -2 -3 2 20 98 50 213 230 874 338 1754 306 2478 -29 661 -116 1081 -295 1424 -193 372 -545 661 -918 753 -109 27 -296 33 -399 14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVts);
export default __webpack_public_path__ + "static/media/vts.472f1b59a6d46c6ebcaf1778d7ab1a61.svg";
export { ForwardRef as ReactComponent };